import type * as React from "react";
import type { FC } from "react";

import * as _ from "lodash";
import styled from "styled-components";

import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import { NOT_AVAILABLE } from "app/filters/const";

import CoreTrendCell from "pro-features/components/core cells/src/CoreTrendCell/CoreTrendCell";

export interface ITrendCellProps {
    value: any[];
    row: any;
    params?: object;
    config?: object;
    Container?: React.FC;
    thresholdMinValue?: number;
    noDataValue?: string;
}

export const TrendContainer: any = styled.div`
    top: -4px;
    position: relative;
    pointer-events: none;
`;
TrendContainer.displayName = "TrendContainer";

const AlignRight = styled.div`
    text-align: right;
`;

export const TrendCell: FC<ITrendCellProps> = ({
    value,
    row,
    params,
    config = {},
    Container = TrendContainer,
    thresholdMinValue,
    noDataValue,
}) => {
    if (_.isEmpty(value)) {
        return <AlignRight>{thresholdMinValue ? `< ${thresholdMinValue}` : (noDataValue ?? NOT_AVAILABLE)}</AlignRight>;
    }
    const trendData = [
        {
            name: `${row?.field}_trend`,
            data: _.sortBy(value.map((item) => [new Date(item.Key || item.key).getTime(), item.Value ?? item.value])),
        },
    ];
    const resConfig = combineConfigs({ value, row, params }, [
        {
            chart: {
                height: 30,
            },
            yAxis: {
                min: 0,
            },
        },
        config,
    ]);
    return (
        <Container>
            <AlignRight>
                <CoreTrendCell
                    data={trendData}
                    config={resConfig}
                    params={params}
                />
            </AlignRight>
        </Container>
    );
};
TrendCell.displayName = "TrendCell";
